import React from "react";

function Hero() {
  return (
    <section className="hero" id="who-we-are">
      <div className="container hero-layout">
        <div className="hero-left">
          <h1>
            Engineering that
            <br />
            reimagines
            <br />
            tomorrow
          </h1>
        </div>
        <div className="hero-right">
          <p>
            Scale-ups, unicorns and modern enterprises around the globe trust
            Vuzenik Technologies to design, build and evolve software from
            ideation to release and beyond.
          </p>
          <p>
            We empower organizations with engineering talent that boosts
            scalability, drives growth and turns bold ideas into reliable
            digital products.
          </p>
          <a href="#what-we-do" className="link-accent">
            Learn more →
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;
